// Pledge detail page (CHG-1248 / ITER-3371).
//
// Thin per the v10 brief: ≤30 LOC. All configuration in @generated/screens.
// Future generator regenerates pledgeDetailConfig from
// pledge.entity-hint.yaml (CHG-1228) without touching this file.
//
// Spec: specs/tier-05-experience/pledge-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { pledgeDetailConfig } from "../generated/screens/pledge-detail";

export function PledgeDetail() {
  return <DetailPage config={pledgeDetailConfig} />;
}
